module.exports = __webpack_public_path__ + "static/media/onboarding-welcome-round3.dfeb66b8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-welcome-round3.mp4
// module id = 2713
// module chunks = 0